/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Code which indicates the vertical pitch (angle).
 */
export type SAPVerticalPitchCodeUIDTOV0 = '1' | '2' | '3' | '4' | '5';

export const SAPVerticalPitchCodeUIDTOV0 = {
    _1: '1' as SAPVerticalPitchCodeUIDTOV0,
    _2: '2' as SAPVerticalPitchCodeUIDTOV0,
    _3: '3' as SAPVerticalPitchCodeUIDTOV0,
    _4: '4' as SAPVerticalPitchCodeUIDTOV0,
    _5: '5' as SAPVerticalPitchCodeUIDTOV0
};

